import { CompactAction, SET_COMPACT } from "./types";

/**
 * Returns a valid action for setting the menu compact state 
 * @param {*} isMenuCompact 
 */
export function setMenuCompactState(isMenuCompact: boolean): CompactAction {
    return {
        type: SET_COMPACT,
        payload: isMenuCompact
    }
}
